var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"maxwindow",staticClass:"framediv"},[_c('iframe',{ref:"dialogSvgframe",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"dialogSvgFrame"}})])}
var staticRenderFns = []

export { render, staticRenderFns }